import { IDatabaseRead } from './IDatabaseRead'
import { IDatabaseWrite } from './IDatabaseWrite'
import ReadFirestore from './ReadFirestore'
import WriteFirestore from './WriteFirestore'

class DatabaseFactory {
  private reference: string
  constructor(reference: string) {
    this.reference = reference
  }
  getReadDatabase(): IDatabaseRead {
    return new ReadFirestore(this.reference)
  }
  getWriteDatabase(): IDatabaseWrite {
    return new WriteFirestore(this.reference)
  }
}

export default DatabaseFactory
